import 'proxy-polyfill';
// import '@fontsource/mukta'
import '@fontsource/mukta/300.css'
import '@fontsource/fira-sans/500.css';

import ReactDOM from 'react-dom/client';

import App from './modules/App';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);
